import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import { useSelector } from "react-redux";

const Profile = () => {
  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/demographic-data?username=${user.username}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        );
        setLoading(false);
        setProfile(res.data);
        console.log(res.data);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };
    fetchProfile();
  }, []);
  return (
    <Box className="parent-div">
      <Header heading={"My Profile"} symbol={true}/>
      <Box
        sx={{ display: "flex", flexDirection: "column", flex: 1 }}
        className="main-container"
      >
        {loading ? (
          "Loading..."
        ) : profile ? (
          <Box>
            <Typography sx={{fontSize: '18px'}}>
              <strong>First Name:</strong> {profile.firstName}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Last Name:</strong> {profile.lastName}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Gender:</strong> {profile.gender}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Education:</strong> {profile.education}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Occupation:</strong> {profile.occupation}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Age:</strong> {profile.age}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>City:</strong> {profile.city}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Durables:</strong>{" "}
              {profile.durables.map((durable) => durable.includes("_") ? `${durable.replace("_", " ")}, ` : `${durable}, `)}
            </Typography>
            <Typography sx={{fontSize: '18px'}}>
              <strong>Apps:</strong>{" "}
              {profile.apps.map((app) => app.includes("_") ? `${app.replace("_", " ")}, ` : `${app}, `)}
            </Typography>
          </Box>
        ) : (
          "No profile data"
        )}
      </Box>
    </Box>
  );
};

export default Profile;
